export const siteConfig = {
  name: "51吃瓜官网",
  title: "51吃瓜官网-51吃瓜莫里秀_大英博物馆_全网独家吃瓜爆料入口_在线看",
  description: "全网独家吃瓜爆料入口已更新，51吃瓜官网带你直击第一现场。深度解析51吃瓜莫里秀与大英博物馆等热门话题背后的秘密，实时追踪网红明星翻车黑料。最新吃瓜网址已同步，高清资源在线看不停，吃瓜无罪八卦有理！",
  keywords: "51吃瓜官网,51吃瓜莫里秀,51吃瓜大英博物馆,51吃瓜爆料入口,51吃瓜在线黑料,51吃瓜最新网址,51吃瓜官网网址,吃瓜51网站,51吃瓜网站免费观看,51吃瓜网站在线观看",
  url: "http://pxkblfc.cn/",
  slogan: "吃瓜无罪 八卦有理",
  tagline: "全网独家吃瓜爆料入口已更新，带你直击第一现场",
};